import styled from 'styled-components'

import CenteredContainer from './CenteredContainer'

const PaddedCenteredContainer = styled(CenteredContainer)<{ padding?: number }>`
  padding-top: ${({ padding }) => (padding || 80) / 2}px;
  padding-bottom: ${({ padding }) => (padding || 80) / 2}px;

  @media (min-width: ${(props) => props.theme.viewport.viewport7}) {
    padding-top: ${({ padding }) => padding || 80}px;
    padding-bottom: ${({ padding }) => padding || 80}px;
  }
`
export default PaddedCenteredContainer
